import { AddTask, RemoveCircleOutline } from '@mui/icons-material';
import { IconButton, MenuItem, Stack, Typography, useTheme } from '@mui/material';
import { Menu, MenuButton } from '@retail/components';
import { useMyAssortmentTFunction } from '@retail/my-assortment/i18n';
import { EditButtonIcon } from '@shared/custom-icons';

interface Props {
  visibleToMembers?: boolean;
  selectableByMembers?: boolean;
  sendEvents?: boolean;
  updateVisibleToMembers: () => void;
  updateSelectableByMembers: () => void;
  updateSendEvents?: () => void;
}

export function UpdateAssortmentTagMenu({
  visibleToMembers,
  selectableByMembers,
  sendEvents,
  updateVisibleToMembers,
  updateSelectableByMembers,
  updateSendEvents,
}: Props) {
  const t = useMyAssortmentTFunction();
  const theme = useTheme();
  const palette = theme.vars.palette;
  return (
    <Menu>
      {({ onClose }) => (
        <>
          <MenuButton component={IconButton}>
            <EditButtonIcon />
          </MenuButton>
          <MenuItem
            sx={{
              '& .MuiSvgIcon-root': {
                fill: visibleToMembers ? palette.secondary.main : palette.success.main,
              },
            }}
            onClick={() => {
              updateVisibleToMembers();
              onClose();
            }}
          >
            <MenuItemView
              isActive={!!visibleToMembers}
              title={
                visibleToMembers
                  ? t('myAssortment.actions.hideFromMember')
                  : t('myAssortment.actions.visibleToMember')
              }
            />
          </MenuItem>
          <MenuItem
            sx={{
              '& .MuiSvgIcon-root': {
                fill: selectableByMembers ? palette.secondary.main : palette.success.main,
              },
            }}
            onClick={() => {
              updateSelectableByMembers();
              onClose();
            }}
          >
            <MenuItemView
              isActive={!!selectableByMembers}
              title={
                selectableByMembers
                  ? t('myAssortment.actions.notSelectableByMember')
                  : t('myAssortment.actions.selectableByMember')
              }
            />
          </MenuItem>
          {updateSendEvents && (
            <MenuItem
              sx={{
                '& .MuiSvgIcon-root': {
                  fill: sendEvents ? palette.secondary.main : palette.success.main,
                },
              }}
              onClick={() => {
                updateSendEvents();
                onClose();
              }}
            >
              <MenuItemView
                isActive={!!sendEvents}
                title={
                  sendEvents
                    ? t('myAssortment.actions.stopSendEvents')
                    : t('myAssortment.actions.sendEvents')
                }
              />
            </MenuItem>
          )}
        </>
      )}
    </Menu>
  );
}

interface MenuItemProps {
  title: string;
  isActive: boolean;
}

export const MenuItemView = ({ title, isActive }: MenuItemProps) => {
  return (
    <Stack flexDirection="row" gap={2} alignItems="center">
      {isActive ? <RemoveCircleOutline fontSize="small" /> : <AddTask fontSize="small" />}

      <Typography>{title}</Typography>
    </Stack>
  );
};
